<template>
  <div>
    <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank"
              @click="$emit('startCSVextraction')">
        <i class="fa-light fa-file-lines"></i>
      </f7-fab>
    </div>
    <button class="showLargeScreenOnly milkyBlockBlack new-button-white firstBlock pull-right"
            @click="$emit('startCSVextraction')">
      <i class="fa-light fa-file-lines"></i>
      <span class="fab-label">{{ $t('common.extract_csv') }}</span>
    </button>
  </div>
</template>
<script>
/** @author TLV 08/01/2021
* @brief Component for extracting csv data
*/

export default {
  name: 'ExtractCSVbutton',
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id)
    }
  }
}
</script>
